import { ModalConteudo as Modal } from './components/modal-conteudo/modal-conteudo.component';

const VisualizarConteudo = {
  Modal,
};

export { VisualizarConteudo };
